import { render, staticRenderFns } from "./BookingReport2.vue?vue&type=template&id=af0ddc2e&"
import script from "./BookingReport2.vue?vue&type=script&lang=js&"
export * from "./BookingReport2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports